import type { GetFilesParams } from '../types';

export const PROJECT_FILE_KEYS = {
  all: (orgId: string) => ['project-files', orgId] as const,
  byProject: (orgId: string, projectId: string) => ['project-files', orgId, projectId] as const,
  list: (orgId: string, projectId: string, params?: GetFilesParams) =>
    ['project-files', orgId, projectId, 'list', params ?? {}] as const,
  detail: (orgId: string, projectId: string, fileId: string) =>
    ['project-files', orgId, projectId, 'detail', fileId] as const,
  counts: (orgId: string, projectId: string) =>
    ['project-files', orgId, projectId, 'counts'] as const,
  previewUrl: (orgId: string, projectId: string, fileId: string) =>
    ['project-files', orgId, projectId, 'preview-url', fileId] as const,
};

export const PROJECT_FOLDER_KEYS = {
  all: (orgId: string) => ['project-folders', orgId] as const,
  byProject: (orgId: string, projectId: string) => ['project-folders', orgId, projectId] as const,
  tree: (orgId: string, projectId: string) =>
    ['project-folders', orgId, projectId, 'tree'] as const,
};
